

































































































import {Message} from 'element-ui';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
dayjs.extend((isSameOrBefore));

import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
@Component
export default class NumberPad extends Vue {
  @Prop() public readonly amount!: number;
  // !为空不警告
  @Prop() public syncNote!: string;
  @Prop(Boolean) public submit!: boolean;
  // output = this.value.toString();
  @Prop() public syncDate!: string;
  @Prop() public use?: string;
  public output = '0';
  public currentButton = '';
  public eDate =  dayjs().format('YYYY-MM-DD');
  public date = '';
  public note = '';
  @Watch('eDate')
  public editDate() {

    if (this.eDate) {
      this.date = dayjs(this.eDate).format('YYYY-MM-DD');
    }
  }
  @Watch('submit')
  public init() {
    this.clear();
    this.$emit('update:submit', false);
  }



  public beforeMount() {
    if (this.$route.query.id) {
      this.output = String(this.amount);
      this.note = this.syncNote;
      this.eDate = String(this.syncDate);
    }

  }
  public mounted() {
      this.editDate();
  }

  get parse() {
    return parseFloat(this.output);
  }

  public checkDate() {
    if (dayjs(this.eDate).isSameOrBefore(dayjs().format('YYYY-MM-DD'), 'date') === false) {
      this.eDate = dayjs().format('YYYY-MM-DD');
      return this.$message({
        message: '请输入今天及之前的日期',
        type: 'warning',
        duration: 1000,
        offset: 200,
      });
    }
  }
  public clearDate() {
    this.eDate = '';
  }


  public control(event: MouseEvent) {
    const button = (event.target as HTMLButtonElement);
    const input = button.innerText!;
    // 忽略类型，防止提示
    if (input === '删除') {
      this.remove();
    } else if (input === '清空') {
      this.clear();
    } else if (input === 'OK') {
      this.ok();
    }
    this.numInput(input);
    this.selectButton(input);
  }

  public numInput(inputButton: string) {
    // let str =
    if (this.output.indexOf('.') >= 0 && inputButton === '.') {
      return;
    }

    if (this.output.length >= 12) {
      // 限制位数
      return;
    }

    if ('0123456789.'.indexOf(inputButton) >= 0) {
      if (this.output === '0' && inputButton !== '.') {
        this.output = inputButton;
        return;
      }
      if (this.output.indexOf('.') > -1 && this.output.length - this.output.indexOf('.') >= 3) {
        // 不允许输入小数点后超过2位的金钱
        return;
      }
      this.output += inputButton;

      return;
    }
  }

  public remove() {
    if (this.output.length === 1) {
      this.output = '0';
      return;
    }
    this.output = this.output.slice(0, -1);
  }

  public clear() {
    this.output = '0';
    this.note = '';
    this.eDate =  dayjs().format('YYYY-MM-DD');
    this.date = this.eDate;
  }

  public ok() {
    // this.$emit('update:amount', this.parse);
    if (this.note.length > 9 ) {
      return this.$message({
        message: '字数超过9个',
        type: 'warning',
        duration: 1000,
        offset: 200,
      });
    }
    if (!this.eDate) {
      return this.$message({
        message: '请填写日期',
        type: 'warning',
        duration: 1000,
        offset: 200,
      });
    }
    if (!this.output) {
      return this.$message({
          message: '请填写价格',
          type: 'warning',
          duration: 2000,
          offset: 150,
        },
      );
    }
    if (!this.note) {
      return this.$message({
          message: '请填写备注',
          type: 'warning',
          duration: 2000,
          offset: 150,
        },
      );

    }


    this.$emit('update:syncNote', this.note);
    this.$emit('update:syncDate', this.date);
    this.$emit('submit', this.parse);
    if (this.use === 'edit') {
      return;
    } else {
      this.clear();
    }


  }

  public selectButton(button: string) {
    this.currentButton = button;
    setTimeout(() => {
      this.currentButton = '';
    }, 200);
  }

}
